import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-pengaturan',
  templateUrl: './pengaturan.component.html',
  styleUrls: ['./pengaturan.component.scss']
})
export class PengaturanComponent {

}
